import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import API from 'services/API';

type UnlinkSubUnitMutationArgs = {
  masterPropertyUid: string;
  subUnitUid: string;
};

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<unknown, BaseErrorResponse, UnlinkSubUnitMutationArgs>,
  'mutationFn' | 'mutationKey'
>;

const unlinkSubUnit = async ({
  masterPropertyUid,
  subUnitUid,
}: UnlinkSubUnitMutationArgs) => {
  const response = await API.post(
    `/api/internal/properties/${masterPropertyUid}/unlink-sub-unit/${subUnitUid}`,
  );
  return response.data;
};

const useUnlinkSubUnitMutation = ({
  ...options
}: ReactQueryMutationOptions = {}) => {
  return useAppMutation({
    mutationFn: unlinkSubUnit,
    ...options,
  });
};

export default useUnlinkSubUnitMutation;
